import * as React from 'react';
import { Button, Form, Upload, UploadProps } from 'antd';
import { FILESIZE_LIMIT, FILES_LIMIT, fileFieldsLabels } from '../false-deals-admin.constants';
import { FileUploadItemProps } from '../false-deals-admin.types';
import { getFilesValidationRule } from '../false-deals-admin.utils';

const FileUploadItem = ({
    name,
    form,
    required = true,
    totalFiles = FILES_LIMIT,
    totalFileSize = FILESIZE_LIMIT,
}: FileUploadItemProps) => {
    const uploadProps: UploadProps = {
        onRemove: (file) => {
            const fileList = form.getFieldValue(name);
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            form.setFieldValue(name, newFileList);
        },
        beforeUpload: () => {
            return false;
        },
        fileList: form.getFieldValue(name) || [],
        multiple: true,
    };

    return (
        <Form.Item
            name={name}
            label={fileFieldsLabels[name]}
            valuePropName="fileList"
            getValueFromEvent={(e) => e.fileList}
            rules={[getFilesValidationRule(required, totalFiles, totalFileSize)]}
            required={required}
        >
            <Upload {...uploadProps}>
                <Button>Выберите файл</Button>
                <p className="text-muted small">{`Не более ${totalFiles} файлов общим объемом не более ${totalFileSize}МБ`}</p>
            </Upload>
        </Form.Item>
    );
};

export default FileUploadItem;
